import React from "react";

import Layout from "../components/Layout";
import OurPhilosophy from "../components/OurPhilosophy";

export default function Philosophy() {
   
    return (
        <Layout>
            <OurPhilosophy />
        </Layout>
    );
}
       